import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";
import ChatMessages from "./utils/ChatMessages";
import ChatClientHealth from "./utils/ChatClientHealth";
import ChatClientControl from "./utils/ChatClientControl";
import ChatAnswered from "./utils/ChatAnswered";
import copy from "copy-to-clipboard";
import {toast} from "react-toastify";

const ChatMain = (props) => {
    const [tab, setTab] = useState('messages');
    const [hideMessagesFromBot, setHideMessagesFromBot] = useState(true);

    const clientID = useSelector(state => state.chat.clientID);

    //console.log("curHideBot:", curHideBot);

    const [hideMessagesCuratorFromBot, setHideMessagesCuratorFromBot] = useState(true);

    const handleClickSetHideMessagesFromBot = (flag) => {
        setHideMessagesFromBot(flag)
    }

    const handleClickSetHideMessagesCuratorFromBot = (flag) => {
        setHideMessagesCuratorFromBot(flag);
        //console.log("flag: ", flag);

        var param = 1;

        if(flag){
            param = 0;
        }

        ///console.log("param: ", param);

        localStorage.setItem('hide_bot_' + clientID, param);

        document.location.reload();
    }

    const copyLinkDialog = () => {
        var link = document.location.protocol + '//' + document.location.host + '/dialog/' + clientID
        copy(link);
        toast.success("Ссылка на диалог скопирована", {position: toast.POSITION.BOTTOM_RIGHT});
    };

    useEffect(() => {
        setTab('messages');

        let curHideBot = localStorage.getItem('hide_bot_' + clientID);

        if(curHideBot === '1'){
            setHideMessagesCuratorFromBot(false);
        }else{
            setHideMessagesCuratorFromBot(true);
        }

        //curHideBot === '1' ? true:false

    }, [clientID]);

    return <main className="main">
        {clientID && <div className="switch">
            <div className="switch__top">
                <div className="switch__top-list">
                    <ul className="switch__list" role="tablist">
                        <li className={"switch__item" + (tab === "messages" ? " switch__item--active" : "")}
                            onClick={() => setTab("messages")}>
                            Сообщения
                        </li>
                        <li className={"switch__item" + (tab === "health" ? " switch__item--active" : "")}
                            onClick={() => setTab("health")}>
                            Анкета здоровья
                        </li>
                        <li className={"switch__item" + (tab === "control" ? " switch__item--active" : "")}
                            onClick={() => setTab("control")}>
                            Контроль
                        </li>
                        <ChatAnswered/>
                    </ul>
                </div>

                <div className="switch__top-actions">
                    <div className="switch__top-action">
                        <div className="show-messages-block js-items-chat-open active">
                            <div className="show-messages-block__top">
                                <img src="/img/copy-link-3.png" className="icon-copy" onClick={copyLinkDialog}/>
                            </div>
                            <div className="show-messages-block__body">
                                <div className="show-messages-block__text js-items-chat-open__btn">
                                    <span onClick={copyLinkDialog}>Cсылка на диалог</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {tab === "messages" && <div className="switch__top-actions">
                    <div className="switch__top-action">
                        <div className="show-messages-block js-items-chat-open active">
                            <div className="show-messages-block__top">
                                <svg>
                                    <use xlinkHref="#robot-face"></use>
                                </svg>
                            </div>
                            <div className="show-messages-block__body">
                                <div className="show-messages-block__text js-items-chat-open__btn">
                                    {!hideMessagesFromBot &&
                                    <span onClick={() => handleClickSetHideMessagesFromBot(true)}>Скрыть сообщения от бота</span>}
                                    {hideMessagesFromBot &&
                                    <span onClick={() => handleClickSetHideMessagesFromBot(false)}>Показать сообщения от бота</span>}
                                </div>
                                <div className="show-messages-block__text js-items-chat-open__btn">
                                    {hideMessagesCuratorFromBot &&
                                    <span onClick={() => handleClickSetHideMessagesCuratorFromBot(false)}>Показать сообщения смены куратора</span>}
                                    {!hideMessagesCuratorFromBot &&
                                    <span onClick={() => handleClickSetHideMessagesCuratorFromBot(true)}>Скрыть сообщения смены куратора</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            <div className="switch__content switch__content--active">
                {tab === "messages" && <ChatMessages hideMessagesFromBot={hideMessagesFromBot} hideMessagesCuratorFromBot={hideMessagesCuratorFromBot}/>}
                {tab === "health" && <ChatClientHealth/>}
                {tab === "control" && <ChatClientControl/>}
            </div>
        </div>}
    </main>;
}

export default ChatMain
